/**
 * TaskSelector Component
 *
 * Dropdown für Aufgaben-Auswahl (4 Modi)
 * @accessibility WCAG 2.1 AA konform
 */

import { useTranslation } from 'react-i18next';
import type { EditTask } from '@/hooks/useImageEditor';

interface TaskSelectorProps {
  value: EditTask;
  onChange: (value: EditTask) => void;
}

export function TaskSelector({ value, onChange }: TaskSelectorProps) {
  const { t } = useTranslation();

  const TASKS = [
    {
      value: 'inpaint_add' as const,
      label: 'Inpaint (Add)',
      description: t('editor.addMode'),
    },
    {
      value: 'inpaint_remove' as const,
      label: 'Inpaint (Remove)',
      description: 'Objekte mit Maske entfernen',
    },
    {
      value: 'outpaint' as const,
      label: 'Outpaint',
      description: t('editor.outpaintMode'),
    },
    {
      value: 'background_edit' as const,
      label: 'Background Editing',
      description: 'Hintergrund ersetzen',
    },
  ];

  return (
    <div className="task-selector space-y-2">
      <label htmlFor="task-select" className="block text-sm font-medium text-neutral-700 dark:text-neutral-300">
        Aufgabe
      </label>
      <select
        id="task-select"
        value={value}
        onChange={(e: React.ChangeEvent<HTMLSelectElement>) => onChange(e.target.value as EditTask)}
        className="w-full px-3 py-2 border border-neutral-300 dark:border-neutral-700 rounded-md bg-white dark:bg-neutral-800 text-neutral-900 dark:text-neutral-100 focus:outline-none focus:ring-2 focus:ring-primary-500"
      >
        {TASKS.map((task) => (
          <option key={task.value} value={task.value}>
            {task.label}
          </option>
        ))}
      </select>
      <p className="text-xs text-neutral-500 dark:text-neutral-400">
        {TASKS.find((task) => task.value === value)?.description}
      </p>
    </div>
  );
}
